<template>
    <b-row class="my-4">
        <b-col class="align-self-center">
            <h4 class="graphics-container-title mb-0">{{$t('dashboard.reports')}}</h4>
        </b-col>
        <b-col>
            <WhiteIconButton
                class="float-right"
                :text="$t('dashboard.export-file')"
                :hideTextMobile="true"
                icon="excel"
                :disabled="busy"
                :emit-this="'export-file'"
                v-on:export-file="downloadFile"
            ></WhiteIconButton>
        </b-col>
    </b-row>
</template>

<script>
    // api (axios)
    import axios from "axios";
    //components
    import WhiteIconButton from "../shared/WhiteIconButton";
    import {mapGetters} from "vuex";
    import {GET_REPORTS_END_DATE, GET_REPORTS_START_DATE} from "../../store/actions/date-time";
    import {GET_SELECTED_DAMS} from "../../store/actions/reports";

    export default {
        name: "ReportsTitle",
        data() {
            return {
                busy: false
            }
        },
        components: {
            WhiteIconButton
        },
        computed: {
            ...mapGetters([GET_REPORTS_START_DATE, GET_REPORTS_END_DATE, GET_SELECTED_DAMS])
        },
        methods: {
            downloadFile() {
                this.busy = true;
                const reqObject = {
                    start: this.GET_REPORTS_START_DATE,
                    end: this.GET_REPORTS_END_DATE,
                    objects: this.GET_SELECTED_DAMS
                };
                const token = localStorage.getItem('user-token');
                axios({
                    url: '/api/export-reports/',
                    method: 'POST',
                    data: reqObject,
                    headers: {
                        'Authorization': `JWT ${token}`
                    },
                    responseType: 'blob',
                }).then((response) => {
                    const timeStamp = + new Date();

                    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    const fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', `export-reports-${timeStamp}.xlsx`);
                    document.body.appendChild(fileLink);
                    fileLink.click();

                    this.busy = false;
                }).catch(() => {
                    this.busy = false;
                    console.error('An error has occurred while downloading file!');
                });
            }
        }
    }
</script>

<style>
</style>